module.exports = __webpack_public_path__ + "static/media/03-homepage3.3b0c2b34.png";